export default {
  name: "neo-checkbox",
  components: {},
  props: ["value", "label", "bg", "borderColor","disabled"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
